/* src/app/forms/acess-view/acess-view.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  font-family: var(--tem-font-family);
}
.acess-main {
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 12px;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.users-panel {
  width: 280px;
  min-width: 240px;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface);
  overflow: hidden;
}
.panel-header {
  padding: 10px 14px;
  background: var(--tem-surface-2);
  border-bottom: 1px solid var(--tem-border);
  font-weight: 600;
  color: var(--tem-ink);
}
.panel-search {
  padding: 8px;
  border-bottom: 1px solid var(--tem-border);
}
.clear-icon {
  color: var(--tem-muted);
  cursor: pointer;
}
.clear-icon:hover {
  color: var(--tem-ink);
}
.users-spin {
  flex: 1;
  display: block;
  overflow: hidden;
}
:host ::ng-deep .users-spin > .ant-spin-container {
  height: 100%;
}
.users-list {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 4px;
  gap: 2px;
}
.user-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: var(--tem-radius);
  cursor: pointer;
  color: var(--tem-ink);
}
.user-row:hover {
  background: var(--tem-accent-soft);
}
.user-row-selected {
  background: var(--tem-accent-soft);
  color: var(--tem-deep);
  font-weight: 600;
}
.user-name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.user-id {
  margin-left: auto;
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
}
.perms-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  overflow: hidden;
}
.perms-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface);
}
.perms-title {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.title-main {
  font-weight: 600;
  font-size: var(--tem-fs-lg);
  color: var(--tem-ink);
}
.title-sub {
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.perms-actions {
  display: flex;
  flex-direction: row;
  gap: 8px;
  white-space: nowrap;
}
.perms-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed var(--tem-border);
  border-radius: var(--tem-radius);
}
.perms-body {
  flex: 1;
  overflow-y: auto;
  padding-right: 2px;
}
/*# sourceMappingURL=acess-view.component.css.map */
